import * as core from '../../../../../../../core'

import { query } from './total-cursor-events.query'

export const RESOURCE = {
  payload: {
    alias: 'total.cursor.events',
    description:
      'Total number of recorded Cursor usage events. Not yet implemented.',
    name: 'Total Cursor Events',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
